import type { FaireProductEntity } from "@faire/playground-entity-db/entity_types/product";
import { getEntityByToken } from "../get_entity";

/**
 * Real, already-imported products spanning scarves, beanies, ponchos, and
 * shawls — a broader assortment than a single-category search so a "fall
 * accessories" query doesn't read as scarves-only.
 */
const FALL_ACCESSORIES_SEARCH_PRODUCT_TOKENS = [
  "p_2g5pfjjwkj",
  "p_2m5bvkaqpt",
  "p_36tvl8hik7",
  "p_43zh9hmtew",
  "p_4qyneyxhfg",
  "p_558pzv49x7",
  "p_5m6vq8pgp5",
  "p_5papqarjrj",
  "p_606ri0voou",
  "p_7563dygugm",
  "p_77d9a9hbfb",
  "p_7gr3wzygqk",
  "p_7xc5ptag52",
  "p_8757zy8tev",
  "p_8zg7k62a83",
  "p_9dhrdqerfs",
  "p_9pd6yotp11",
  "p_9szgntsaza",
  "p_9wjkqz3wuq",
  "p_ajc5gtfpan",
  "p_bx5rbxy3va",
  "p_cag49qlfzl",
  "p_dgnkxz9tpz",
  "p_ehgd244bby",
  "p_f2vgrthtn9",
  "p_fa4mn9v22s",
  "p_g7m6grvxrh",
  "p_gkbyg87f2p",
  "p_gq5zuzvf38",
  "p_hdsjwk36u7",
  "p_huzvhcwact",
  "p_hybf9gwsyh",
  "p_j9an3w8ykh",
  "p_jd3k3c33c7",
  "p_kj23yyepe3",
  "p_krbqmfccbb",
  "p_kuzb5h8zh4",
  "p_mg5ved2yw6",
  "p_nue5mt5rh2",
  "p_p79xnpg4sw",
  "p_pzm7n52pjh",
  "p_qmzq9x6yd6",
  "p_quqp6p9vf7",
  "p_shjzef8gkq",
  "p_txfqaebg9h",
  "p_ug44pmerzk",
  "p_v4tjuquvbn",
  "p_vzmvedpg94",
  "p_x8f6xuxfgy",
  "p_xbgateqs35",
  "p_xm8ckeeeuz",
  "p_yfnpdjd5t6",
  "p_zh9psmjtrc",
  "p_zyjzwmdm52",
];

export const fallAccessoriesSearchProducts: FaireProductEntity[] =
  FALL_ACCESSORIES_SEARCH_PRODUCT_TOKENS.map((token) =>
    getEntityByToken(token, "product")
  ).filter(
    (product: FaireProductEntity | undefined): product is FaireProductEntity =>
      product !== undefined
  );
